import Grid from "@material-ui/core/Grid";
import * as React from "react";
import { useHistory, useLocation } from "react-router-dom";
import LetterListComponent from "./letter.list.component";
import LetterDetailsComponent from "./letter.details.component";




function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  
export default function Letter() {
    const history = useHistory();
    const query = useQuery();
  
    return (
        <div>
           {query.get("mode") === "create" ? (
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "flex-start",
              marginBottom: "20px",
              height: "2em",
              color: "#000",
              fontSize: "18px",
              fontWeight: 600,
            }}
          >
           
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                Letter Management- Create
              </span>
            
          </Grid>
          ) : null}
    
          {(() => {
            switch (query.get("mode")) {
              case "viewList":
                return <LetterListComponent />;
              case "create":
                return <LetterDetailsComponent />;
              default:
                history.push("/claims/letter?mode=viewList");
            }
          })()}
        </div>
      );
}